import { Component, Input, OnInit } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-grid-daterange-filter',
  templateUrl: './grid-daterange-filter.component.html',
  styleUrls: ['./grid-daterange-filter.component.css']
})
export class GridDaterangeFilterComponent  extends BaseFilterCellComponent implements OnInit {

  @Input()
  public filter: CompositeFilterDescriptor;

  @Input()
  public field: string;

  constructor(filterService: FilterService) {
    super(filterService);
  }

  public get start(): Date {
    const first = this.findByOperator('gte');

    return (first || ({} as FilterDescriptor)).value;
  }

  public get end(): Date {
    const end = this.findByOperator('lte');
    return (end || ({} as FilterDescriptor)).value;
  }

  public get hasFilter(): boolean {
    return this.filtersByField(this.field).length > 0;
  }

  public clearFilter(): void {
    this.filterService.filter(
      this.removeFilter(this.field)
    );
  }

  public filterRange(start: Date, end: Date): void {
    this.filter = this.removeFilter(this.field);

    const filters = [];

    if (start) {
      filters.push({
        field: this.field,
        operator: 'gte',
        value: start
      });
    }

    if (end) {
      filters.push({
        field: this.field,
        operator: 'lte',
        value: end
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: []
    };

    if (filters.length) {
      root.filters.push(...filters);
    }

    this.filterService.filter(root);
  }

  private findByOperator(op: string): FilterDescriptor {
    return this.filtersByField(this.field)
      .filter(({ operator }) => operator === op)[0];
  }

  ngOnInit() {
  }



}
